import { DynamicFormRoot } from './_dynamic_form_root.component';
import { DynamicFormActions } from './_dynamic_form_actions.component';
import { DynamicFormDescription } from './_dynamic_form_description.component';
import { DynamicFormContent } from './_dynamic_form_content.component';

export const DynamicForm = {
	Root: DynamicFormRoot,
	Description: DynamicFormDescription,
	Content: DynamicFormContent,
	Actions: DynamicFormActions,
};
